// CLASS UserInfo:
export class UserInfo {
    constructor({ profileNameSelector, profileOccupationSelector, profileAvatarSelector }) {
        this._profileName = document.querySelector(profileNameSelector);
        this._profileOccupation = document.querySelector(profileOccupationSelector);
        this._profileAvatar = document.querySelector(profileAvatarSelector);
    }

    getUserInfo() {
        return { 
            name: this._profileName.textContent, 
            occupation: this._profileOccupation.textContent,
            avatar: this._profileAvatar,
        };
    }
    setNewAvatar({ newUserAvatar }) {
        this._profileAvatar.src = newUserAvatar;
    }
    
    setUserInfo({ newUserName, newUserOccupation }) {
        this._profileName.textContent = newUserName;
        this._profileOccupation.textContent  = newUserOccupation;
    }
}